module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/~/symbol-observable/index.js
// module id = 698
// module chunks = 0